module.exports = __webpack_public_path__ + "img/onebilliondollars.e3c3506.gif";